import {
  List,
  Datagrid,
  TextField,
  DateField,
  EditButton,
  DeleteButton,
  TopToolbar,
  CreateButton,
  ExportButton,
  NumberField,
  DeleteWithConfirmButton,
} from "react-admin";

const NewsListActions = () => (
  <TopToolbar>
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

export const HighlightNewsList = () => {
  return (
    <List actions={<NewsListActions />}>
      <Datagrid rowClick="show" optimized>
        <NumberField source="id" />
        <TextField source="title" />
        <TextField source="shortContent" />
        <DateField source="createdAt" />
        <TextField source="thumbnail" />
        <TextField source="tags" />
        <DeleteWithConfirmButton />
      </Datagrid>
    </List>
  );
};
